module.exports = __webpack_public_path__ + "static/img/IMG_20170301_162506.06664a6f.jpg";